var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoverIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    y: 0.375,
    width: 18.6846,
    height: 17.8945,
    fill: "#0F172A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56065 11.5481C7.70924 11.4058 7.95013 11.4058 8.09872 11.5481L10.1125 13.4768L12.1263 11.5481C12.2748 11.4058 12.5157 11.4058 12.6643 11.5481C12.8129 11.6904 12.8129 11.9211 12.6643 12.0634L10.3815 14.2497C10.2329 14.392 9.99204 14.392 9.84346 14.2497L7.56065 12.0634C7.41207 11.9211 7.41207 11.6904 7.56065 11.5481Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56065 7.11203C7.70924 7.25432 7.95013 7.25432 8.09872 7.11203L10.1125 5.1834L12.1263 7.11203C12.2748 7.25432 12.5157 7.25432 12.6643 7.11203C12.8129 6.96973 12.8129 6.73901 12.6643 6.59671L10.3815 4.41044C10.2329 4.26814 9.99204 4.26814 9.84346 4.41044L7.56065 6.59671C7.41207 6.73901 7.41207 6.96973 7.56065 7.11203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoverIcon);
export default __webpack_public_path__ + "static/media/MoverIcon.54155704a5e1e337c770aec6d82655a4.svg";
export { ForwardRef as ReactComponent };